import React from 'react';
import { StatoEvasione } from '../types';

interface StatoEvasioneBadgeProps {
  statoEvasione?: StatoEvasione | null;
  wmsOrderId?: string | null;
}

const LABELS: Record<StatoEvasione, string> = {
  non_evaso: 'Non evaso',
  in_preparazione: 'In preparazione',
  in_spedizione: 'In spedizione',
  spedito: 'Spedito',
  annullato: 'Annullato',
};

const COLORS: Record<StatoEvasione, string> = {
  non_evaso: 'bg-gray-100 text-gray-800',
  in_preparazione: 'bg-blue-100 text-blue-800',
  in_spedizione: 'bg-orange-100 text-orange-800',
  spedito: 'bg-green-100 text-green-800',
  annullato: 'bg-red-100 text-red-800',
};

const StatoEvasioneBadge: React.FC<StatoEvasioneBadgeProps> = ({ statoEvasione, wmsOrderId }) => {
  if (!wmsOrderId || !statoEvasione) return null;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${COLORS[statoEvasione]}`}>
      {LABELS[statoEvasione]}
    </span>
  );
};

export default StatoEvasioneBadge;
